import './GradientText.css';

export default function GradientText({
  text,
  className = '',
  showGlow = false,
  opacity,
}) {
  const classes = [
    'GradientText',
    showGlow ? 'GradientText--glow' : '',
    className,
  ].filter(Boolean).join(' ');
  const style = opacity !== undefined ? { '--gradient-text-opacity': opacity } : undefined;

  return (
    <div className={classes} style={style}>
      {text}
    </div>
  );
}
